import { definePathHelper } from "@js-from-routes/axios";

const RESOURCES_ORG_END_POINT = `${process.env.resourcesApiUrl}/v1/orgs`;

export default {
  getOrgs: definePathHelper("get", RESOURCES_ORG_END_POINT),
};
